import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";

const videoSlides = [
  {
    src: "/assets/banner03_v1.mp4",
    legend: "Découvrez les Changan",
    cta: "Explorez la gamme",
    link: "/catalogue",
    mobile: "/assets/banner02_v1.mp4",
  },
  {
    src: "/assets/hero-video1.mp4",
    legend: "Découvrez la puissance",
    cta: "Explorer",
    link: "/catalogue",
    mobile: "/assets/banner1.jpg",
  },
  {
    src: "/assets/arrivage.mp4",
    legend: "Un temps de dépotage exceptionnel",
    cta: "Explorer",
    link: "/catalogue",
    mobile: "/assets/depotagem.mp4",
  },
  {
    src: "/assets/hero-video2.mp4",
    legend: "Élégance et performance",
    cta: "Nos véhicules",
    link: "/marques",
    mobile: "/assets/kv2.jpg",
  },
  {
    src: "/assets/hero-video7.mp4",
    legend: "De ELIAKIM A THE BRIDGE",
    cta: "Passe par nous",
    link: "",
    mobile: "/assets/hero-video7.mp4",
  },
  {
    src: "/assets/commande_livre.mp4",
    legend: "Tout Togolais, un véhicule",
    cta: "Passer votre commande",
    link: "",
    mobile: "/assets/commande_livre.mp4",
  },
  {
    src: "/assets/hero-video3.mp4",
    legend: "Technologie de pointe",
    cta: "En savoir plus",
    link: "/contact",
    mobile: "/assets/banner3.jpg",
  },
  {
    src: "/assets/home_3.png",
    legend: "Technologie de pointe #1",
    cta: "En savoir plus",
    link: "/contact",
    mobile: "/assets/home_5_m.jpg",
  },
];

const isVideo = (url = "") => url.toLowerCase().endsWith(".mp4");
const SLIDE_INTERVAL = 9000;

export default function HeroSection() {
  const carouselRef = useRef(null);
  const desktopVideoRefs = useRef([]);
  const endedHandlersRef = useRef([]);
  const [, setLoading] = useState(true);

  const readyOnceRef = useRef(false);

  const markReady = () => {
    if (readyOnceRef.current) return;
    readyOnceRef.current = true;
    setLoading(false);
  };

  const playActiveVideo = (activeIndex) => {
    desktopVideoRefs.current.forEach((videoEl) => {
      if (!videoEl) return;

      try {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.preload = "metadata";
      } catch (e) {
        console.error("Erreur pause vidéo :", e);
      }
    });

    const activeVideo = desktopVideoRefs.current[activeIndex];

    if (activeVideo) {
      try {
        activeVideo.preload = "auto";
        activeVideo.play().catch(() => {});
      } catch (e) {
        console.error("Erreur lecture vidéo active :", e);
      }
    }
  };

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    const videoElements = desktopVideoRefs.current;

    const carousel = bootstrap.Carousel.getOrCreateInstance(el, {
      interval: SLIDE_INTERVAL,
      ride: true,
      pause: false,
    });

    endedHandlersRef.current = videoSlides.map(() => {
      return () => carousel.next();
    });

    videoElements.forEach((videoEl, i) => {
      if (videoEl?.tagName === "VIDEO") {
        videoEl.addEventListener("ended", endedHandlersRef.current[i]);
      }
    });

    const onSlid = (e) => {
      const nextIndex = typeof e?.to === "number" ? e.to : 0;
      playActiveVideo(nextIndex);
    };

    el.addEventListener("slid.bs.carousel", onSlid);

    playActiveVideo(0);

    return () => {
      el.removeEventListener("slid.bs.carousel", onSlid);

      videoElements.forEach((videoEl, i) => {
        if (videoEl?.tagName === "VIDEO") {
          const handler = endedHandlersRef.current[i];
          if (handler) {
            videoEl.removeEventListener("ended", handler);
          }
        }
      });
    };
  }, []);

  return (
    <div
      id="heroCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      ref={carouselRef}
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <div className="carousel-indicators">
        {videoSlides.map((_, i) => (
          <button
            key={i}
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide-to={i}
            className={i === 0 ? "active" : ""}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <div className="carousel-inner w-100 h-100">
        {videoSlides.map((slide, i) => {
          const desktopIsVideo = isVideo(slide.src);
          const mobileIsVideo = isVideo(slide.mobile);

          return (
            <div
              key={i}
              className={`carousel-item h-100 ${i === 0 ? "active" : ""}`}
            >
              {/* DESKTOP */}
              {desktopIsVideo ? (
                <video
                  ref={(el) => {
                    desktopVideoRefs.current[i] = el;
                  }}
                  muted
                  playsInline
                  loop={false}
                  preload="metadata"
                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover d-none d-md-block"
                  style={{ zIndex: 0 }}
                  onCanPlayThrough={() => i === 0 && markReady()}
                >
                  <source src={slide.src} type="video/mp4" />
                </video>
              ) : (
                <img
                  src={slide.src}
                  alt={`Slide ${i + 1}`}
                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover d-none d-md-block"
                  style={{ zIndex: 0 }}
                  loading={i === 0 ? "eager" : "lazy"}
                  onLoad={() => i === 0 && markReady()}
                />
              )}

              {/* MOBILE */}
              {mobileIsVideo ? (
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="w-100 h-100 object-fit-cover d-block d-md-none position-absolute top-0 start-0"
                  style={{ zIndex: 0 }}
                  onCanPlayThrough={() => i === 0 && markReady()}
                >
                  <source src={slide.mobile} type="video/mp4" />
                </video>
              ) : (
                <img
                  src={slide.mobile}
                  alt={`Version mobile du slide ${i + 1}`}
                  className="w-100 h-100 object-fit-cover d-block d-md-none position-absolute top-0 start-0"
                  style={{ zIndex: 0 }}
                  loading={i === 0 ? "eager" : "lazy"}
                  onLoad={() => i === 0 && markReady()}
                />
              )}

              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: 1 }}
              />

              <div
                className="position-relative text-white d-flex flex-column justify-content-center align-items-center text-center h-100 px-3"
                style={{ zIndex: 2 }}
              >
                <h1 className="display-4 fw-bold mb-3">{slide.legend}</h1>

                {slide.link ? (
                  <Link to={slide.link} className="btn btn-bridge btn-lg">
                    {slide.cta}
                  </Link>
                ) : (
                  <button className="btn btn-bridge btn-lg" type="button">
                    {slide.cta}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Précédent</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Suivant</span>
      </button>
    </div>
  );
}